export default "__VITE_ASSET__BBl1bZS___"